import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function PublicNav() {
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  const links = [
    { to: "/", label: "Home" },
    { to: "/chi-siamo", label: "Chi siamo" },
    { to: "/perche", label: "Perché" },
    { to: "/galleria", label: "La Galleria" },
    { to: "/agenzie", label: "Le Agenzie Partner" },
    { to: "/perche-diventare-partner", label: "Diventa Partner" },
  ];
  const close = () => setOpen(false);

  return (
    <header className="border-b border-[#E6E4E0] paper-bg sticky top-0 z-40 backdrop-blur">
      <div className="max-w-[1240px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between gap-6">
        <div className="leading-none shrink-0">
          <Link to="/" onClick={close} data-testid="nav-home-logo">
            <div className="font-serif text-base md:text-lg lg:text-xl text-[#7D2E3F] tracking-[0.12em] whitespace-nowrap">PRONTO ALLA VENDITA</div>
          </Link>
          {/* Porta segreta staff: click sul micro-testo "by RX CASA" apre l'area riservata */}
          <Link to="/admin/login" data-testid="nav-staff-secret" title="Area riservata"
                className="block label-uppercase mt-1 text-[#5C5657] text-[10px] hover:text-[#7D2E3F] cursor-pointer select-none">
            by RX CASA
          </Link>
        </div>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-6 lg:gap-8 flex-1 justify-end">
          {links.map((l) => (
            l.hash ? (
              <a key={l.to} href={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/ /g,"-")}-link`}
                 className="text-sm tracking-wide text-[#3A3D42] hover:text-[#7D2E3F] whitespace-nowrap">{l.label}</a>
            ) : (
              <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/ /g,"-")}-link`}
                    className={`text-sm tracking-wide whitespace-nowrap ${loc.pathname === l.to ? "text-[#7D2E3F]" : "text-[#3A3D42] hover:text-[#7D2E3F]"}`}>
                {l.label}
              </Link>
            )
          ))}
        </nav>

        {/* Mobile hamburger */}
        <button
          onClick={() => setOpen(!open)}
          className="md:hidden flex flex-col gap-[5px] w-8 h-8 items-center justify-center"
          aria-label={open ? "Chiudi menu" : "Apri menu"}
          data-testid="nav-mobile-toggle"
        >
          <span className={`block w-6 h-[1.5px] bg-[#3A3D42] transition-transform ${open ? "translate-y-[6.5px] rotate-45" : ""}`} />
          <span className={`block w-6 h-[1.5px] bg-[#3A3D42] transition-opacity ${open ? "opacity-0" : ""}`} />
          <span className={`block w-6 h-[1.5px] bg-[#3A3D42] transition-transform ${open ? "-translate-y-[6.5px] -rotate-45" : ""}`} />
        </button>
      </div>

      {/* Mobile menu panel */}
      {open && (
        <div className="md:hidden border-t border-[#E6E4E0] paper-bg" data-testid="nav-mobile-panel">
          <nav className="max-w-[1240px] mx-auto px-6 py-6 flex flex-col divide-y divide-[#E6E4E0]">
            {links.map((l) => (
              l.hash ? (
                <a key={l.to} href={l.to} onClick={close}
                   data-testid={`nav-mobile-${l.label.toLowerCase().replace(/ /g,"-")}`}
                   className="font-serif text-2xl py-4 text-[#3A3D42]">{l.label}</a>
              ) : (
                <Link key={l.to} to={l.to} onClick={close}
                      data-testid={`nav-mobile-${l.label.toLowerCase().replace(/ /g,"-")}`}
                      className={`font-serif text-2xl py-4 ${loc.pathname === l.to ? "text-[#7D2E3F]" : "text-[#3A3D42]"}`}>{l.label}</Link>
              )
            ))}
            <Link to="/form" onClick={close} data-testid="nav-mobile-cta" className="btn-primary text-xs !mt-6 text-center">
              Scopri se la tua casa può entrare
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
